export const getLocalStorageInstance = (): Storage | null => {
  return typeof window === 'undefined' ? null : window.localStorage;
};
